(function() {
  'use strict';

  let isLoading = false;

  function initLoadMore() {
    const button = document.getElementById('LoadMoreButton');
    const spinner = document.getElementById('LoadMoreSpinner');
    
    if (!button) return;

    // Only add listener if not already initialized
    if (!button.hasAttribute('data-initialized')) {
      button.addEventListener('click', handleLoadMore);
      button.setAttribute('data-initialized', 'true');
    }
  }

  async function handleLoadMore(event) {
    event.preventDefault();
    
    if (isLoading) return;

    const button = event.currentTarget;
    const spinner = document.getElementById('LoadMoreSpinner');
    const currentPage = parseInt(button.dataset.currentPage) || 1;
    const totalPages = parseInt(button.dataset.totalPages) || 1;
    const sectionId = button.dataset.sectionId;
    const collectionHandle = button.dataset.collectionHandle;

    if (currentPage >= totalPages) {
      hideButton(button, spinner);
      return;
    }

    const nextPage = currentPage + 1;
    setLoadingState(button, spinner, true);

    try {
      // Get current URL parameters (for filters, sorting, etc.)
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('section_id', sectionId);
      currentParams.set('page', nextPage);

      const url = `/collections/${collectionHandle}?${currentParams.toString()}`;
      
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the product grid in the fetched HTML
      const fetchedGrid = doc.getElementById('product-grid');
      if (!fetchedGrid) {
        throw new Error('Product grid not found in response');
      }

      // Get the current product grid
      const currentGrid = document.getElementById('product-grid');
      if (!currentGrid) {
        throw new Error('Current product grid not found');
      }

      // Extract product items from the fetched grid
      const newProducts = fetchedGrid.querySelectorAll('li.grid__item');
      
      if (newProducts.length === 0) {
        hideButton(button, spinner);
        return;
      }

      // Append new products to the current grid with fade-in animation
      newProducts.forEach((product, index) => {
        // Clone the node to avoid issues with event listeners
        const clonedProduct = product.cloneNode(true);
        // Set animation delay before adding to DOM for smoother animation
        clonedProduct.style.animationDelay = `${index * 0.05}s`;
        // Add fade-in class for smooth appearance
        clonedProduct.classList.add('load-more-product-fade-in');
        currentGrid.appendChild(clonedProduct);
      });

      // Update banner positions if they exist
      updateBannerPositions();

      // Update button state
      button.dataset.currentPage = nextPage;
      
      if (nextPage >= totalPages) {
        hideButton(button, spinner);
      }

      // Reinitialize scroll animations if available
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(currentGrid.innerHTML);
      }

    } catch (error) {
      console.error('Error loading more products:', error);
      // Silently fail - just hide the button and spinner
      hideButton(button, spinner);
    } finally {
      setLoadingState(button, spinner, false);
    }
  }

  function setLoadingState(button, spinner, loading) {
    isLoading = loading;
    const wrapper = button.closest('.load-more-wrapper');
    
    if (loading) {
      // Hide button visually but keep its space, show spinner
      button.style.opacity = '0';
      button.style.visibility = 'hidden';
      button.style.pointerEvents = 'none';
      if (spinner) {
        spinner.classList.remove('hidden');
      }
    } else {
      // Show button and hide spinner (only if there are more pages)
      const currentPage = parseInt(button.dataset.currentPage) || 1;
      const totalPages = parseInt(button.dataset.totalPages) || 1;
      
      if (currentPage < totalPages) {
        button.style.opacity = '1';
        button.style.visibility = 'visible';
        button.style.pointerEvents = 'auto';
      }
      if (spinner) {
        spinner.classList.add('hidden');
      }
    }
  }

  function hideButton(button, spinner) {
    if (button) {
      button.style.display = 'none';
    }
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }

  function updateBannerPositions() {
    const productCards = document.querySelectorAll('#product-grid .grid__item');
    const banner = document.getElementById('dynamic-banner');
    const secondBanner = document.getElementById('second-dynamic-banner');

    if (banner && productCards.length >= 4) {
      // Check if banner is already inserted
      if (!banner.parentElement || banner.parentElement.id !== 'product-grid') {
        productCards[3].after(banner);
        banner.classList.remove('hidden');
      }
    }

    if (secondBanner) {
      // Check if second banner is already inserted
      if (!secondBanner.parentElement || secondBanner.parentElement.id !== 'product-grid') {
        if (productCards.length >= 8 && productCards.length < 12) {
          productCards[7].after(secondBanner);
          secondBanner.classList.remove('hidden');
        } else if (productCards.length >= 12) {
          productCards[11].after(secondBanner);
          secondBanner.classList.remove('hidden');
        }
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }

  // Re-initialize when ProductGridContainer is updated (e.g., when filters are applied)
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Check if Load More button exists and hasn't been initialized yet
          const button = document.getElementById('LoadMoreButton');
          if (button && !button.hasAttribute('data-initialized')) {
            button.setAttribute('data-initialized', 'true');
            button.addEventListener('click', handleLoadMore);
          }
        }
      });
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
})();
